export const PRODUCTION_APP = process.env.REACT_APP_PRODUCTION;
export const isProduction = process.env.REACT_APP_PRODUCTION === 'true';
export const DEV_PORTAL_APP_ID = process.env.REACT_APP_DEV_PORTAL_APP_ID;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const DEX_URL = process.env.REACT_APP_DEX_URL;
export const DEV_PORTAL_API_URL = process.env.REACT_APP_DEV_PORTAL_API_URL;
export const VERSION = '2.4.0';

export const AUTH_LOGIN_URL =
  `${AUTH_URL}/services/login?` +
  `application_id=${DEV_PORTAL_APP_ID}&redirect_uri=${window.location.origin}/authenticate/hat`;

export const EXTERNAL_LINKS = {
  dataswiftDocs: 'https://docs.dataswift.io/',
  dataswiftAuth: 'https://docs.dataswift.io/guides/pda-auth-guide',
  dataswiftSSO: 'https://docs.dataswift.io/reference/single-sign-on',
  dataswiftStack: 'https://docs.dataswift.io/tutorials/build-your-own-hat-backend#technology-stack',
  dataswiftArchitecture: 'https://docs.dataswift.io/reference/hat-microserver',
  dataswiftGuide: 'https://docs.dataswift.io/guides',
  dataswiftBuildPlug: 'https://docs.dataswift.io/reference/building-a-data-plug',
  dataswiftPDA: 'https://docs.dataswift.io/reference/pda-functions',
  datasiwftAPI: 'https://documenter.getpostman.com/view/110376/S1EH4ha8',
  hubGithub: 'https://github.com/dataswift',
};

export const menuItems: IDrawerMenuItems = {
  developer: [
    {
      menuId: 'apps',
      menuName: 'My Apps',
      link: 'apps',
    },
    {
      menuId: 'resources',
      menuName: 'Resources',
      link: 'resources',
    },
    {
      menuId: 'settings',
      menuName: 'Account Settings',
      link: 'settings',
    },
    {
      menuId: 'testingRoles',
      menuName: 'Testing Roles',
      link: 'testingRoles',
    },
  ],
  manager: [
    {
      menuId: 'apps',
      menuName: 'Apps',
      link: '/manager',
    },
    {
      menuId: 'settings',
      menuName: 'Account Settings',
      link: '/manager/settings',
    },
  ],
  admin: [
    {
      menuId: 'apps',
      menuName: 'Apps',
      link: '/admin',
    },
    {
      menuId: 'users',
      menuName: 'Users',
      link: '/admin/users',
    },
    {
      menuId: 'settings',
      menuName: 'Account Settings',
      link: '/admin/settings',
    },
  ],
};

type IDrawerMenuItems = {
  developer: IDrawerMenuFields[];
  manager: IDrawerMenuFields[];
  [index: string]: IDrawerMenuFields[];
};

type IDrawerMenuFields = {
  menuId: string;
  menuName: string;
  link: string;
};

export const FEATURES = {
  beta: {
    enabled: PRODUCTION_APP ? PRODUCTION_APP !== 'true' : false,
  },
  themeSwitch: {
    enabled: PRODUCTION_APP ? PRODUCTION_APP !== 'true' : false,
  },
};
